import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Profile() {
    const [data, setData] = useState({
        type: '',
        firstname: '',
        lastname: '',
        phone: ''
    });
    const [isEditing, setIsEditing] = useState(false);
    const [id, setId] = useState(null);
    const [originalData, setOriginalData] = useState({});
    const Email = localStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`https://api.eazyworldehsengineering.com/api/admin/${Email}`);
                const userData = {
                    type: 'update',
                    firstname: response.data.firstname,
                    lastname: response.data.lastname,
                    phone: response.data.phone || ''
                };
                setData(userData);
                setOriginalData(userData);
                setId(response.data.id);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, [Email]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData(prev => ({ ...prev, [name]: value }));
    };

    const handleEdit = () => setIsEditing(true);
    const handleCancel = () => {
        setData(originalData);
        setIsEditing(false);
    };

    const handleSave = async () => {
        try {
            await axios.put(`https://api.eazyworldehsengineering.com/api/admin/${id}`, data);
            setIsEditing(false);
            localStorage.setItem('name', data.firstname + data.lastname);
        } catch (error) {
            console.error('Error saving data:', error);
        }
    };

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-3">
                        <div className="col-sm-6">
                            <h1 className="m-0">Profile</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Profile</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <div className="card shadow-lg border-0">
                            <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                                <h4 className="mb-0"><i className="fas fa-user-circle me-2"></i>Profile Details</h4>
                                {!isEditing && (
                                    <button className="btn btn-light btn-sm" onClick={handleEdit}>
                                        <i className="fas fa-edit"></i> Edit
                                    </button>
                                )}
                            </div>
                            <div className="card-body">
                                <form>
                                    <div className="row mb-3">
                                        <div className="col-sm-6">
                                            <label className="form-label">First Name</label>
                                            <input type="text" name="firstname" value={data.firstname} onChange={handleInputChange} className="form-control" disabled={!isEditing} />
                                        </div>
                                        <div className="col-sm-6">
                                            <label className="form-label">Last Name</label>
                                            <input type="text" name="lastname" value={data.lastname} onChange={handleInputChange} className="form-control" disabled={!isEditing} />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-sm-6">
                                            <label className="form-label">Phone</label>
                                            <input type="text" name="phone" value={data.phone} onChange={handleInputChange} className="form-control" disabled={!isEditing} />
                                        </div>
                                        <div className="col-sm-6">
                                            <label className="form-label">Email</label>
                                            <input type="text" value={Email} className="form-control" disabled />
                                        </div>
                                    </div>

                                    {isEditing && (
                                        <div className="mt-3">
                                            <button type="button" className="btn btn-success me-2" onClick={handleSave}>
                                                <i className="fas fa-save"></i> Save
                                            </button>
                                            <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                                                <i className="fas fa-times"></i> Cancel
                                            </button>
                                        </div>
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Profile;
